module.exports = __webpack_public_path__ + "static/black-october-home-detail-1ff595fdad9dcd21026bee34c3de604b.png";